'use client'

import React, {
  createContext,
  useContext,
  ReactNode,
  RefObject,
  forwardRef,
} from 'react'
import { useInView } from 'framer-motion'

// Context에서 제공할 값의 타입 정의
interface AlarmTooltipContextType {
  show: boolean
}

// 초기값 설정
const AlarmTooltipContext = createContext<AlarmTooltipContextType | undefined>(
  undefined,
)

// Props 타입 정의
interface AlarmTooltipProviderProps {
  children: ReactNode
}

// Context Provider with forwarded ref
export const AlarmTooltipProvider = forwardRef<
  Element,
  AlarmTooltipProviderProps
>(({ children }, ref) => {
  // Ensure the ref is properly forwarded
  const show = useInView(ref as RefObject<Element>, {})
  return (
    <AlarmTooltipContext.Provider value={{ show }}>
      {children}
    </AlarmTooltipContext.Provider>
  )
})

AlarmTooltipProvider.displayName = 'AlarmTooltipProvider'

// Hook to use the alarm tooltip state
export const useAlarmTooltipShow = (): AlarmTooltipContextType => {
  const context = useContext(AlarmTooltipContext)
  if (!context) {
    throw new Error(
      'useAlarmTooltipShow must be used within an AlarmTooltipProvider',
    )
  }
  return context
}
